import { Ruler } from "@phosphor-icons/react";
import { SectionShell } from "../Primitives";
import { SPACING } from "@/data/designTokens";

export function SpacingSection() {
  return (
    <SectionShell
      id="spacing"
      eyebrow="Spacing"
      eyebrowIcon={Ruler}
      title="A calm 4-point rhythm"
      description="Everything aligns to a 4px base on an 8-point rhythm. Generous, consistent spacing gives content room to breathe — a key ingredient of the premium, uncluttered feel."
    >
      <div className="rounded-3xl border border-border bg-card p-6 shadow-soft md:p-8">
        <div className="space-y-3">
          {SPACING.map((s) => (
            <div key={s.token} className="flex items-center gap-4">
              <div className="flex w-16 flex-shrink-0 items-baseline gap-1">
                <span className="font-display text-base font-extrabold">{s.token}</span>
              </div>
              <div className="flex h-8 items-center rounded-lg bg-primary/15" style={{ width: `${s.px * 2}px`, minWidth: 8 }}>
                <div className="h-8 rounded-lg bg-primary" style={{ width: `${s.px * 2}px` }} />
              </div>
              <div className="flex items-center gap-3 text-sm">
                <span className="font-bold text-foreground">{s.px}px</span>
                <code className="rounded-md bg-muted px-2 py-0.5 font-mono text-xs font-semibold text-muted-foreground">
                  p-{s.cls}
                </code>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5 grid gap-4 sm:grid-cols-3">
        {[
          { t: "Inside cards", v: "24px", d: "Comfortable padding" },
          { t: "Between items", v: "16–24px", d: "Clear separation" },
          { t: "Between sections", v: "48–96px", d: "Spacious rhythm" },
        ].map((x) => (
          <div key={x.t} className="rounded-2xl border border-border bg-card p-5 shadow-soft">
            <p className="font-display text-2xl font-extrabold text-primary-strong">{x.v}</p>
            <p className="mt-1 font-bold">{x.t}</p>
            <p className="text-sm font-semibold text-muted-foreground">{x.d}</p>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}

export default SpacingSection;
